export type Orientation = "portrait" | "landscape";

type Coordinates = readonly [number, number];

export type Center =
  | Coordinates
  | {
      type: "Point";
      coordinates: Coordinates;
    };

export type Bounds = {
  type: "Polygon";
  coordinates: Coordinates[];
};

export const isCoordinates = (item: Center): item is Coordinates => {
  return Array.isArray(item);
};

export type Scale = "200" | "500" | "1250" | "2500";

export type PageSize = "A3" | "A4";

export type S3Asset = {
  asset_type: string;
  created: string;
  modified: string;
  s3_id: string;
  _id: string;
};
